import React, { useState } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
    Modal,
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    CardText,
    Table,
} from 'reactstrap';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import { Field, Form } from 'react-final-form';
import axios from "axios";
import { useDispatch, flashSuccess, flashError } from "@/shared/components/flash"

const BulkReclaimModal = ({ organization, program, selectedRows, isOpen, setOpen, toggle, theme, rtl, user, setTrigger, }) => {
    const dispatch = useDispatch()
    const [results, setResults] = useState(null)

    const closeAndReset = () => {
        // Refreshing the underlying table resets react-table's row
        // selection, which unmounts this modal (the parent only renders it
        // while selectedRows.length > 0) — so the refresh must wait until
        // the admin is done with this modal, not fire while results are
        // still on screen. Deferring it here covers both paths: it runs
        // immediately for the all-succeeded case (which closes right away)
        // and only after the admin reviews results on partial failure.
        setTrigger(Math.floor(Date.now() / 1000))
        setResults(null)
        toggle()
    }

    const onSubmitChangeStatus = values => {
        let formData = {
            "program_id": program.id,
            "notes": values.notes,
            "reclaim_data": selectedRows.map(item => ({
                "amount": item.amount,
                "program_id": item.program_id,
                "journal_event_id": item.journal_event_id,
                "event_xml_data_id": item.event_xml_data_id,
                "participant_id": item.user_account_holder_id
            }))
        }
        axios.post(`/organization/${organization.id}/program/${program.id}/bulk-reclaim`, formData)
            .then((res) => {
                if (res.status == 200) {
                    const perPersonResults = (res.data.data || []).map(entry => {
                        const row = selectedRows.find(r => r.user_account_holder_id === entry.user_id)
                        return {
                            first_name: row?.first_name,
                            last_name: row?.last_name,
                            success: !!entry.result?.success,
                            error: entry.result?.error,
                        }
                    })
                    const allSucceeded = perPersonResults.every(r => r.success)

                    if (allSucceeded) {
                        flashSuccess(dispatch, "Reclaim Awards successfully!")
                        closeAndReset()
                    } else {
                        const failedCount = perPersonResults.filter(r => !r.success).length
                        flashError(dispatch, `${failedCount} of ${perPersonResults.length} reclaims failed. See details below.`)
                        setResults(perPersonResults)
                    }
                }
            })
            .catch(error => {
                console.log(error.response.data);
                flashError(dispatch, error.response.data)
            })
    }

    return (
        <Modal className={`modal-action modal-md ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={closeAndReset}>
            <Card className='w-100'>
                <CardHeader tag="h3">
                    Reclaim
                    <Button className='btn float-end' close onClick={closeAndReset} />
                </CardHeader>
                <CardBody>
                    {results ? (
                        <>
                            <CardTitle className='text-left'>Reclaim Results</CardTitle>
                            <Table className='table table-borderless table-striped'>
                                <thead>
                                    <tr>
                                        <th>Participant</th>
                                        <th>Status</th>
                                        <th>Reason</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {results.map((r, i) => (
                                        <tr key={`result-${i}`}>
                                            <td>{r.last_name}, {r.first_name}</td>
                                            <td>{r.success ? 'Reclaimed' : 'Failed'}</td>
                                            <td>{r.success ? '' : r.error}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className='row d-flex justify-content-end'>
                                <Button className='btn-sm' color='primary' onClick={closeAndReset}>Close</Button>
                            </div>
                        </>
                    ) : (
                        <>
                            <CardTitle className='text-left'>Reclaiming Awards! </CardTitle>
                            <CardText className='text-left mb-2'>Selected Awards for Reclaim: </CardText>
                            <Form
                                onSubmit={onSubmitChangeStatus}
                                validate={() => ({})}
                                initialValues={{
                                    // user_status_id: String(user.status.id)
                                }}
                            >
                                {({ handleSubmit }) => (
                                    <form className="form" onSubmit={handleSubmit}>
                                        <div className='form__form-group label-mb-0'>
                                            {selectedRows.map((item) => (
                                                <li>{item.last_name}, {item.first_name}: </li>
                                            ))}
                                        </div>
                                        <Field name="notes">
                                            {({ input, meta }) => (
                                                <div className="form__form-group">
                                                    <span className="form__form-group-label">Notes for Reclaim: </span>
                                                    <div className="form__form-group-field">
                                                        <div className="form__form-group-row">
                                                            <input type="text" {...input} />
                                                            {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Field>
                                        <div className='row d-flex justify-content-end'>
                                            <Button className='btn-sm mr-2' color='primary' type='submit'>Reclaim Awards</Button>
                                            <Button className='btn-sm' color='outline-primary' onClick={closeAndReset}>Cancel</Button>
                                        </div>
                                    </form>
                                )}
                            </Form>
                        </>
                    )}
                </CardBody>
            </Card>
        </Modal>
    )
}

BulkReclaimModal.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired
};

export default withRouter(connect((state) => ({
    theme: state.theme,
    rtl: state.rtl,
    organization: state.organization
}))(BulkReclaimModal));
